// action - state management
import { REGISTER, LOGIN, LOGOUT, CLEAN } from './actions';

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false
      };
    }
    case CLEAN: {
      return {
        ...state,
        user: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default auth;
